import Button from 'components/form/Button';
import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { useDispatch } from 'react-redux';
import { handleResourceAllocation, throwSuccess } from 'store/slices';
import { objectToFormData } from 'utils/helpers';

const AllocateDropdown = ({
  resourceList,
  selectedIds,
  eventId,
  setIsReAllocation,
}) => {
  
// console.log('✌️selectedIds --->', selectedIds);
  const [selectedValues, setSelectedValues] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false); 
  const dispatch = useDispatch();

  
  // Toggle selection
  const handleSelect = (value) => {
    setSelectedValues((prevSelected) =>
      prevSelected.includes(value)
        ? prevSelected.filter((item) => item !== value)
        : [...prevSelected, value]
    );
  };

  const handleApply = async () => {
    setIsReAllocation(false);
    const payload = {
      event_id: eventId,
      resource_id: selectedValues,
      abstract_id: selectedIds,
    };
    setIsLoading(true);
    const response = await dispatch(
      handleResourceAllocation(objectToFormData(payload))
    );
    if (response.status === 200) {
      dispatch(throwSuccess(response?.message));
      setSelectedValues([]);
      setShow(false);
      setIsReAllocation(true);
    }
    setIsLoading(false);
  };

  const handleClear = () => {
    setSelectedValues([]);
    setShow(false);
  };

  return (
    <Dropdown show={show} onToggle={(isOpen) => setShow(isOpen)} >
      <Dropdown.Toggle
        as="div"
        className={`d-flex align-items-center gap-2 text-14-400-18 br-6 ${show ? "bg-new-car color-white": 'bg-f4fc'}`}
        style={{ cursor: 'pointer', padding: '8px 14px' }}
        onClick={() => setShow(!show)}
      >
        Allocate To
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ minWidth: '250px', maxWidth: '400px' }}>
        {/* Custom Options List */}
        <div
          className="cmb-5"
          style={{ maxHeight: '242px', overflowY: 'auto' }}
        >
          {resourceList?.map((option, index) => {
            const isOdd = index % 2 !== 0;
            const isSelected = selectedValues.includes(option.resource_id);
            return (
              <div
                key={option.resource_id}
                className={`d-flex justify-content-between align-items-center gap-2 cps-14 cpt-10 cpb-10 cpe-14 ${
                  isOdd ? 'bg-f4fc' : ''
                }`}
                style={{ cursor: 'pointer' }}
                onClick={() => handleSelect(option.resource_id)}
              >
                {`${option.resource_name} (${option.paper_count})`}
                {isSelected && (
                  <i className="bi bi-check2 color-new-car ms-2 fs-4" />
                )}
              </div>
            );
          })}
        </div>

        {/* Buttons Section */}
        <div className="d-flex align-items-center justify-content-start cps-14 cpt-14 cpb-14 cpe-14 gap-3 border-top">
          <Button
            text="Confirm Allocate"
            btnStyle="primary-dark"
            className="text-14-500-18 h-35 text-nowrap"
            onClick={handleApply}
            btnLoading={isLoading}
            disabled={isLoading}
          />
          <Button
            text="Cancel"
            btnStyle="primary-outline"
            className="text-14-500-18 h-35 text-nowrap"
            onClick={handleClear}
            disabled={isLoading}
          />
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AllocateDropdown;
